import { EButtonIntents } from '@src/typings';
import { cva } from 'class-variance-authority';

export const buttonVariants = cva('shadow-none', {
    variants: {
        intent: {
            [EButtonIntents.Filled]: 'border-0',
            [EButtonIntents.LightFilled]: 'border-0',
            [EButtonIntents.Linear]: 'border',
            [EButtonIntents.LightLinear]: 'border',
            [EButtonIntents.Text]: 'border-none',
        },
        size: {
            xs: 'text-xs !px-2 !py-1',
            sm: 'text-xs !p-2',
            md: 'text-base !p-3',
            lg: 'text-base !px-4 !py-3',
            xl: 'text-base !px-4 !py-3',
        },
        rounded: {
            normal: 'rounded-lg',
            full: 'rounded-full',
            lg: 'rounded-lg',
        },
        display: {
            inline: '',
            justifyBetween: '',
        },
        _content: {
            text: '',
            textAndIcon: 'inline-flex items-center',
            textAndIconJustify:
                'justify-between items-center w-full inline-flex gap-x-1',
            icon: 'flex items-center justify-center',
        },
    },
    compoundVariants: [
        { size: ['xs', 'sm'], className: 'font-normal' },
        { size: ['md', 'lg', 'xl'], className: 'font-medium' },
        { size: ['xs', 'sm'], rounded: 'normal', className: 'rounded' },
        {
            size: ['md', 'lg', 'xl'],
            rounded: 'normal',
            className: 'rounded-md',
        },
        { size: ['xs', 'sm'], rounded: 'full', className: 'rounded-full' },
        {
            size: ['md', 'lg', 'xl'],
            rounded: 'full',
            className: 'rounded-full',
        },
        { size: ['xs', 'sm'], rounded: 'lg', className: 'rounded-lg' },
        { size: ['md', 'lg', 'xl'], rounded: 'lg', className: 'rounded-lg' },
        {
            size: ['xs', 'sm'],
            _content: ['text', 'textAndIcon'],
            className: 'gap-x-1 px-2 py-1',
        },
        {
            size: ['md', 'lg', 'xl'],
            _content: ['text', 'textAndIcon'],
            className: 'gap-x-1',
        },
        {
            size: ['xs', 'sm'],
            display: 'justifyBetween',
            _content: ['textAndIconJustify'],
            className: 'px-2 py-1 w-full',
        },
        {
            size: ['md', 'lg', 'xl'],
            display: 'justifyBetween',
            _content: ['textAndIconJustify'],
            className: 'p-3 w-full',
        },
        {
            size: 'md',
            _content: ['text', 'textAndIcon'],
            className: 'px-2.5 py-1.5',
        },
        {
            size: 'lg',
            _content: ['text', 'textAndIcon'],
            className: 'p-3',
        },
        {
            size: 'xl',
            _content: ['text', 'textAndIcon'],
            className: 'p-3',
        },
        { size: 'xs', _content: 'icon', className: 'px-2 py-1' },
        { size: 'sm', _content: 'icon', className: 'p-2' },
        { size: 'md', _content: 'icon', className: 'p-3' },
        { size: 'lg', _content: 'icon', className: 'px-4 py-3' },
        { size: 'xl', _content: 'icon', className: 'px-4 py-3' },
    ],
    defaultVariants: {
        intent: EButtonIntents.Filled,
        size: 'md',
        rounded: 'lg',
        _content: 'text',
        display: 'inline',
    },
});
